import { t } from "i18next";
import TabsMobile from "../../__template/TabsMobileComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { ChangeEvent, Fragment, useEffect, useState } from "react";
import users from "../../../assets/images/icon_profile/user.svg";
import Config from "../../../config/Config";
import { Range } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import DateRangePicker from "../../common/DateRangePicker";
import Voice from "../../../assets/images/icon_recitation/voice.svg";
import Common from "../../../assets/images/icon_recitation/common.svg";
import Setoran from "../../../assets/images/icon_recitation/dashboard_setoran.svg";
import TidakSetoran from "../../../assets/images/icon_recitation/dashboard_tidak_setoran.svg";
import { Dialog, Disclosure, Transition } from "@headlessui/react";
import {
  ArrowPathIcon,
  ChevronUpIcon,
  CloudArrowUpIcon,
} from "@heroicons/react/20/solid";
import {
  getDataRecitation,
  getDataRecitationRecap,
  getSubTypeRecitation,
  getSummaryRecitation,
  getTypeRecitation,
} from "../../../core/service/api_recitation";
import moment from "moment";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../core/feature/config/configSlice";
import { toast } from "react-toastify";
import {
  CardRecap,
  Recaptype,
} from "../../../common/cardRecapRecitationComponent";

type DashboardData = {
  setoran: number;
  tidak_setoran: number;
};

const RecitationSubmissionReportMobile = () => {
  const env = Config.BaseUrlDev;
  const location: any = useLocation();
  const [child, setChild] = useState<any>({});
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenProcess, setIsProcess] = useState<boolean>(false);
  const [setoranList, setSetoranList] = useState([]);
  const [typeRecitationList, setTypeRecitationList] = useState([]);
  const [recitationType, setRecitationType] = useState<string>("");
  const [filterRecitationMethod, setFilterRecitationMethod] =
    useState<string>("");
  const [dashboardData, setDashboardData] = useState<DashboardData>(
    {} as DashboardData
  );
  const dispatch = useDispatch();
  const [page, setPage] = useState<number>(0);
  const [totalPage, setTotalPage] = useState<number>(0);

  const [selectedRange, setSelectedRange] = useState({
    startDate: "",
    endDate: "",
    key: "selection",
  });

  const company = JSON.parse(localStorage.getItem("company")!);
  const [query, setQuery] = useState([
    `caller_id=${location.state.data.callerId}`,
    `caller_name=${location.state.data.name}`,
    `company_id=${company.id}`,
  ]);

  const [filter, setFilter] = useState({
    year: moment().year(),
    month: moment().month() + 1,
    // Do not send a week until the user explicitly selects one.
    week: "",
  });

  const yearOptions = Array.from({ length: 3 }).map((_, item) => {
    let year = moment().year();
    return year - item;
  });

  const weekOptions = [
    { label: "Semua Pekan", value: "" },
    ...[1, 2, 3, 4, 5].map((week) => ({
      label: `Pekan ${week}`,
      value: week,
    })),
  ];

  const monthOptions = [
    { label: "Januari", value: 1 },
    { label: "Februari", value: 2 },
    { label: "Maret", value: 3 },
    { label: "April", value: 4 },
    { label: "Mei", value: 5 },
    { label: "Juni", value: 6 },
    { label: "Juli", value: 7 },
    { label: "Agustus", value: 8 },
    { label: "September", value: 9 },
    { label: "Oktober", value: 10 },
    { label: "November", value: 11 },
    { label: "Desember", value: 12 },
  ];

  const navigate = useNavigate();

  const handleDateChange = (range: any) => {
    setSelectedRange(range);
  };

  useEffect(() => {
    getData();
    console.log(filter);
  }, [filter]);

  const loadMoreData = () => {
    setPage((prevPage) => prevPage + 1);
    dispatch(setLoading(true));
    let queryData = [
      `caller_id=${location.state.data.callerId}`,
      `company_id=${company.id}`,
      `year=${filter.year}`,
      `month=${filter.month}`,
      ...(filter.week ? [`week=${filter.week}`] : []),
      `page=${page + 1}`,
      "size=10",
    ];
    getDataRecitationRecap(queryData)
      .then(({ data }) => {
        console.log(data);
        setTotalPage(data.totalPages);
        setSetoranList(setoranList.concat(data.content));
      })
      .catch(() => {
        toast.error("Something went wrong");
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
    console.log("total page", totalPage);
  };
  const getData = () => {
    dispatch(setLoading(true));
    let queryData = [
      `caller_id=${location.state.data.callerId}`,
      `company_id=${company.id}`,
      `year=${filter.year}`,
      `month=${filter.month}`,
      ...(filter.week ? [`week=${filter.week}`] : []),
      `page=${page}`,
      "size=10",
    ];
    getDataRecitationRecap(queryData)
      .then(({ data }) => {
        console.log(data);
        setSetoranList(data.content);
        setTotalPage(data.totalPages);
      })
      .catch(() => {
        toast.error("Something went wrong");
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  useEffect(() => {
    console.log(location.state.data);
    setChild(location.state.data);
    getData();
  }, []);

  const getProfileImage = (photo: string) => {
    if (photo == "") return users;
    return env + "main_a/image/get/" + photo + "/pas";
  };

  const handleChangeFilter = (label: string, value: any) => {
    setFilter((e) => ({ ...e, [label]: value }));
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const openProcess = () => {
    setIsProcess(true);
    setTimeout(() => {
      closeProcess();
    }, 3000);
  };

  const closeProcess = () => {
    setIsProcess(false);
  };

  const handleUploadFile = () => {
    openProcess();
  };
  return (
    <>
      <div className="relative min-h-screen h-full bg-psp-primary pb-10 font-montserrat">
        <div className="flex flex-col p-2">
          <div className="bg-white p-2 rounded-3xl flex-row flex gap-3 items-center">
            <img
              src={getProfileImage(child.photoUrl)}
              alt="profile"
              className="w-14 h-14 rounded-full flex-0 object-cover"
            />
            <div className="flex flex-col grow">
              <h1 className="font-montserrat text-xs  font-medium text-psp-nav">
                {t("RECITATION.welcome")}
              </h1>
              <h1 className="font-montserrat text-sm font-bold">
                {child.name?.split(" ").length > 3
                  ? child.name?.split(" ").slice(0, 2).join(" ")
                  : child.name}
              </h1>
              <p className="font-montserrat text-xs text-gray-600">
                NIS: {child.callerId}
              </p>
            </div>
          </div>
          <section className="mt-4 p-2">
            <div className="flex gap-3 font-sans flex-col gap-2">
              <span className="text-gray-700 text-sm font-medium mr-1">
                Filter
              </span>
              <div className="flex items-center gap-2">
                <div className="relative">
                  <select
                    value={filter.year}
                    onChange={(e) => handleChangeFilter("year", e.target.value)}
                    className="appearance-none w-full bg-white border border-gray-300 text-gray-700 py-1.5 pl-4 pr-8 rounded-full text-sm leading-tight focus:outline-none focus:bg-white focus:border-gray-500 cursor-pointer"
                  >
                    {yearOptions.map((item: number, index: number) => {
                      return (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      );
                    })}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                    </svg>
                  </div>
                </div>
                <div className="relative">
                  <select
                    value={filter.month}
                    onChange={(e) =>
                      handleChangeFilter("month", e.target.value)
                    }
                    className="appearance-none w-full bg-white border border-gray-300 text-gray-700 py-1.5 pl-4 pr-8 rounded-full text-sm leading-tight focus:outline-none focus:bg-white focus:border-gray-500 cursor-pointer"
                  >
                    {monthOptions.map((item: any, index: number) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                    </svg>
                  </div>
                </div>
                <div className="relative">
                  <select
                    value={filter.week}
                    onChange={(e) => handleChangeFilter("week", e.target.value)}
                    className="appearance-none w-full bg-white border border-gray-300 text-gray-700 py-1.5 pl-4 pr-8 rounded-full text-sm leading-tight focus:outline-none focus:bg-white focus:border-gray-500 cursor-pointer"
                  >
                    {weekOptions.map((item, index: number) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="mt-4">
            <div className="p-2">
              <p className="text-lg font-bold">
                {t("RECITATION.recitationHistory")}
              </p>
              <div className="flex flex-col gap-2 justify-items-center">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                  {setoranList.length > 0 &&
                    setoranList.map((item: Recaptype, index: number) => (
                      <CardRecap key={item._id} data={item} />
                    ))}
                </div>
                {page + 1 < totalPage ? (
                  <div className="flex w-full">
                    <button
                      onClick={loadMoreData}
                      className={`w-full bg-psp-btn-primary px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active ${"text-white"}`}
                    >
                      {t("OTHER.showMore")}
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default RecitationSubmissionReportMobile;
